import { AxiosResponse } from 'axios';
import { SET_FAYDA, SET_FAYDA_USER_INFO, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CREATE_FAYDA_AUTH_URL,
  FAYDA_EXCHANGE_CODE,
  CLEAR_FAYDA_ISLOADING,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Fayda from '@/services/fayda';
import { Module } from 'vuex';
import { CreateFaydaAuthUrl, FaydaExchangeCode } from '@/dtos/fayda.dto';

const fayda: Module<any, {}> = {
  state: {
    fayda: {
      data: null,
      isLoading: false,
    },
    faydaUserInfo: {
      data: null,
    },
  },
  getters: {
    fayda: (state: { fayda: any }) => state.fayda,
    faydaUserInfo: (state: { faydaUserInfo: any }) => state.faydaUserInfo,
  },
  mutations: {
    [SET_FAYDA]: (
      state: { fayda: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.fayda.data = payload.data) : null,
        (state.fayda.isLoading = payload.isLoading);
    },
    [SET_FAYDA_USER_INFO]: (
      state: { faydaUserInfo: { data: any } },
      payload: any
    ) => {
      state.faydaUserInfo.data = payload;
    },
  },
  actions: {
    [CREATE_FAYDA_AUTH_URL]: async ({ commit }: any, payload: CreateFaydaAuthUrl) => {
      commit(SET_FAYDA, { data: null, isLoading: true });

      const result: AxiosResponse = await Fayda.createAuthUrl(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_FAYDA, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_FAYDA, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FAYDA, { isLoading: false });
        return false;
      }
    },
    [FAYDA_EXCHANGE_CODE]: async ({ commit }: any, payload: FaydaExchangeCode) => {
      commit(SET_FAYDA, { data: null, isLoading: true });

      const result: AxiosResponse = await Fayda.exchangeCodeAndFetchUserInfo(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_FAYDA, { data: result.data.data, isLoading: false });
          commit(SET_FAYDA_USER_INFO, result.data.data);
          return result.data.data;
        }
        commit(SET_FAYDA, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_FAYDA, { isLoading: false });
        return false;
      }
    },
    [CLEAR_FAYDA_ISLOADING]: ({ commit }) => {
      commit(SET_FAYDA, { isLoading: false });
    },
  },
};

export default fayda;

